module.exports = __webpack_public_path__ + "static/img/la-4.29bf305.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/ComicDetail/img/link-active/la-4.png
// module id = 171
// module chunks = 0